//this js for IE only because object-fit property doesn't work
//and image size is wrong
//added 27-04-2020
var win = jQuery(window);
win.on({
  'load': fixedImageSizeIE,
  'resize': fixedImageSizeIE
});

function iterateItems(flag) {
  var activeClass = 'ie-fix';
  jQuery('.rb-editorial__background').each(function () {
    var current = jQuery(this),
      img = current.find('source'),
      url = img.attr('srcset');

    if(flag) {
      current.addClass(activeClass);
      current.css({
        'backgroundImage': 'url('+ url +')'
      });
    }
    else {
      current.removeClass(activeClass);
      current.css({
        'backgroundImage': ''
      });
    }
  });
}

function fixedImageSizeIE() {
  var userAgent = window.navigator.userAgent,
    ieReg = /msie|Trident.*rv[ :]*11\./gi,
    ie = ieReg.test(userAgent),
    winWidth = win.width(),
    point = 1024;

  if(ie && winWidth <= point) {
    iterateItems(true);
  }else {
    iterateItems();
  }
}
